export default __webpack_public_path__ + "assets/img/ab-test/introduce_01.png";